import { observable } from "mobx";
import { Type } from "class-transformer";
import CompetitionListItem from "./competitionListItem";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class CompetitionList {
  @observable
  total!: number;

  @observable
  @Type(() => CompetitionListItem)
  competitions!: CompetitionListItem[];

  static ValidationRules = {
    total: { required: true, number: true },
    competitions: { required: true },
  };
}
